import HelperMixin from '../../../Shared/HelperMixin';

export default {
    mixins: [HelperMixin],
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            From: '',
            To: '',
            Level: '',

            ScreenTitle: ' دفعات تليينك ',
            ScreenTitleSingle: ' دفعة ',

            Info: [],
            Statistics: {
                Count: 0,
                TotalAmount: 0,
                SuccessCount: 0,
                FailedCount: 0,
                InitiatedCount: 0
            },

            Levels: [
                { id: 1, name: 'بدأت (Initiated)' },
                { id: 2, name: 'ناجحة (Success)' },
                { id: 3, name: 'فاشلة (Failed)' }
            ]
        };
    },

    methods: {
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            this.$blockUI.Start();
            
            let fromStr = this.From ? this.$helper.FormatDate(this.From) : '';
            let toStr = this.To ? this.$helper.FormatDate(this.To) : '';

            this.$http.GetTlyncPayments(this.pageNo, this.pageSize, this.Search, fromStr, toStr, this.Level)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        GetLevelTag(level) {
            if (level === 1) return 'info';
            if (level === 2) return 'success';
            if (level === 3) return 'danger';
            return '';
        },

        GetLevelName(level) {
            let item = this.Levels.find(x => x.id === level);
            return item ? item.name : 'Unknown';
        }
    },

    mounted() {
        this.GetInfo();
    }
};
